// extracted by mini-css-extract-plugin
var _1 = "h7fsC";
var _2 = "RhUvI";
var _3 = "UjTNt";
var _4 = "C7piT";
var _5 = "mWDem";
export { _1 as "headerText", _2 as "searchWrapper", _3 as "shopButton", _4 as "subcriptionsPage", _5 as "suggestedActionContainer" }
